export const opacity = (value: number): string => {
    const norm = Math.max(0, Math.min(1, value));
    const to8bit = Math.ceil(norm * 255);
    const hex = to8bit.toString(16);

    if (hex.length === 1) {
        return `0${hex}`;
    } else {
        return hex;
    }
};

export const blue = '#25b1be';
export const blue10 = blue + opacity(0.1);
export const blue20 = blue + opacity(0.2);
export const blue30 = blue + opacity(0.3);
export const blue40 = blue + opacity(0.4);
export const darkBlue = '#0b0028';
export const red = '#fb2d62';
export const redLight = red + opacity(0.2);
export const charcoal = '#1c1c1c';
export const charcoalLight = '#1c1c1cb3';
export const mediumGrey = '#575d5d';
export const moonlight = '#efefef';
export const backgroundMedium = '#f6f6f8';
export const concrete = '#bbbbbb';
export const grey25 = '#9d9c9c40';
export const greyNew = '#f5f5f5';
export const green = '#93d99e';
export const mint = '#39d99e';
export const orange = '#f6632b';
export const yellow = '#f9b559';
export const white = '#ffffff';
export const transparent = 'transparent';
export const independence = '#3c4257';

export const fontColor = charcoal;
export const fontColorLight = charcoal + opacity(0.66);
export const fontColorError = red;
export const linkColor = blue;
